import { Modify } from "../utilities/modifyType";
import Asset from "./Asset";
import { toAssetCategory } from "./AssetCategory";
import { AssetDataType } from "./AssetType";
import { LibraryItem } from "./LibraryItem";
import { LibraryItemType } from "./LibraryItemType";
import { LinkAssetType } from "./LinkAssetType";

export interface LinkAsset extends Asset {
    // Link url
    url: string;
    assetType: AssetDataType;
}

export type SerializedLinkAsset = Modify<LinkAsset, {
    category: string,
    dateAccessed: string,
    dateCreated: string,
    dateModified: string,
    datePreached?: string,
    assetType: undefined
}>;

export const deserializeLinkAsset = (linkAsset:SerializedLinkAsset): LinkAsset => {
    return {
        ...linkAsset,
        category: toAssetCategory(linkAsset.category),
        dateAccessed: new Date(linkAsset.dateAccessed),
        dateCreated: new Date(linkAsset.dateCreated),
        dateModified: new Date(linkAsset.dateModified),
        datePreached: linkAsset.datePreached ? new Date(linkAsset.datePreached) : undefined,
        assetType: AssetDataType.Link
    }   
}

export function convertLinkAssetToLibraryItem(linkAsset: LinkAsset): LibraryItem {
    return {
        ...linkAsset,
        category: linkAsset.category,
        customSlideBackgroundImagePath: undefined,
        type: LibraryItemType.LinkAsset,
        isShared: false,
        isTemplate: false,
        templateDescription: "",
        slideExporterAspectRatio: "16x9",
        linkUrl: linkAsset.url,
        linkType: getLinkAssetType(linkAsset.url)
    }
}

export function getLinkAssetType(linkUrl?: string) {
    if (!linkUrl) {
        return undefined;
    }
    if (linkUrl.indexOf("youtube://") === 0) {
        return LinkAssetType.YouTube;
    }
    if (linkUrl.indexOf("vimeo://") === 0) {
        return LinkAssetType.Vimeo;
    }
    if (linkUrl.indexOf("soundcloud://") === 0) {
        return LinkAssetType.SoundCloud;
    }
    return LinkAssetType.General;
}